<template>
  <div
    class="navRecordsUser"
    :class="{ active: isActive, valid: valid, invalid: invalid }"
    @click="handleClick"
  >
    <div class="navRecordsUser__content">
      <span>{{ subtitle }}</span>
      <p>{{ name }}</p>
      <div
        v-if="deleteable"
        @click="dialogVisible = true"
      >
        <md-icon name="delete" />
      </div>
      <div class="navRecordsUser__bubble">
        {{ bubble }}
        <span
          v-if="parseInt(notification) > 0"
          class="navRecordsUser__bubble--notification"
        >{{ notification }}</span>
      </div>
    </div>

    <el-dialog
      class="recordCard__dialog"
      :title="$t('records.nav.deleteTitle')"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <p>{{ $t('records.nav.deleteReally') }}&nbsp;<span class="primaryColor">{{ name }}</span>&nbsp;?</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">{{$t('records.nav.deleteCancel')}}</el-button>
        <el-button
          :loading="dialogLoading"
          @click="handleDelete"
        >{{ $t('records.nav.deleteConfirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "NavRecordsUser",
  props: {
    name: {
      type: String,
      default: "..."
    },
    subtitle: {
      type: String,
      default: null
    },
    bubble: {
      type: String,
      default: null
    },
    notification: {
      type: [Number, String],
      default: null
    },
    type: {
      type: String,
      default: null
    },
    targetId: {
      type: Number,
      default: null
    },
    bordered: {
      type: Boolean,
      default: false
    },
    deleteable: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialogVisible: false,
    dialogLoading: false
  }),
  computed: {
    isActive() {
      if (this.$route.params) {
        if (this.$route.params.person_id) {
          const personId = parseInt(this.$route.params.person_id)

          if (personId === this.targetId) return true
        }

        if (this.$route.params.guarantor_id) {
          const guarantId = parseInt(this.$route.params.guarantor_id)

          if (guarantId == this.targetId) return true
        }

        if (this.$route.params.tenant_id) {
          const tenantId = parseInt(this.$route.params.tenant_id)

          if (tenantId === this.targetId) return true
        }
      }

      return false
    }
  },
  methods: {
    handleClick() {
      if (this.type) {
        let recordId = this.$route.params.id

        switch (this.type) {
          case 'guarant':
            return this.$router.push({ path: '/dossiers/' + recordId + '/modification-de-garant/' + this.targetId })
          case 'tenant':
            return this.$router.push({ path: '/dossiers/' + recordId + '/modification-de-locataire/' + this.targetId })
          case 'justif':
            return this.$router.push({ path: '/dossiers/' + recordId + '/pieces-justificatives/' + this.targetId })
        }
      }
    },
    async handleDelete() {
      try {
        this.dialogLoading = true
        let recordId = this.$route.params.id

        // Delete
        /* await this.$store.dispatch('recordsPeople/deletePerson', {
          id: this.targetId,
          type: this.type
        }) */

        // Detach
        await this.$store.dispatch('records/detachPerson', {
          recordId,
          id: this.targetId,
          type: this.type
        })

        switch (this.type) {
          case 'guarant':
            return this.$router.push({ path: '/dossiers/' + recordId + '/ajout-de-garant' })
          case 'tenant':
            return this.$router.push({ path: '/dossiers/' + recordId + '/ajout-de-locataire' })
        }

        this.$notify({
          type: 'success',
          title: this.$t('base.success.notificationTitle'),
          message: this.$t('base.success.deleteWithSuccess')
        })
      } catch (error) {
        console.warn(error)
      }


      this.dialogVisible = false
      this.dialogLoading = false
    }
  }
}
</script>
